module.exports = __webpack_public_path__ + "img/passo_02.dbcdeabe.png";